import { Component, Input } from '@angular/core';
import { NavItem } from './../shared/models/nav-item';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html'
})
export class NavItemComponent  {
  @Input() navItem: NavItem;

}
